export const SOFTLINE_API_WEBDOC = '/v1/webdoc/documents';
export const SOFTLINE_API_WEBDOC_DOCUMENT_INFORMATION = '/v1/webdoc/document-information';
export const SOFTLINE_API_WEBDOC_FAVORITES = '/v1/webdoc/favorites';
export const SOFTLINE_API_WEBDOC_DOWNLOAD = '/v1/webdoc/download-document';
export const SOFTLINE_API_WEBDOC_DELETE_FILE = '/v1/webdoc/delete-file';
export const SOFTLINE_API_WEBDOC_EDIT_FILE_NAME= '/v1/webdoc/update';
export const SOFTLINE_API_WEBDOC_SEARCH= '/v1/webdoc/find/documents';
export const SOFTLINE_API_WEBDOC_MENU_ITEM = '/v1/webdoc/find/menu-item';

export const SOFTLINE_API_SUPPLIER = '/supplier-service/supplier/{{id}}'
export const SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER = '/dfh_supplier_data_carrier-service/dfh-data-carrier/{{supplierId}}';
export const SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER_COLUMNS = '/dfh_supplier_data_carrier-service/dfh-data-carrier/{{format}}/export-columns';
export const SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER_EXPORT = '/dfh_supplier_data_carrier-service/dfh-data-carrier/{{supplierId}}/export-data-carrier';
export const SOFTLINE_API_DFH_DATA_CARRIER_UPDATE_SUPPLIER_COLUMNS = '/dfh_supplier_data_carrier-service/dfh-data-carrier/update-export-columns';
